import axios from 'axios';

// Separate public client: no auth refresh, tenant headers or metadata cache.
const client = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}/api/public`,
  withCredentials: true,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

export const softwareRegistrationAPI = {
  publicCatalogue: config => client.get('/software-tariffs/catalogue', { ...config, withCredentials: false }),
  loginSession: () => client.post('/software-registration-drafts/checkout/session', {}, {timeout:60000}),
  prepareContract: config => client.post('/software-registration-drafts/contract/prepare', {}, {...config, timeout:60000}),
  currentContractPreview: (order_id, config) => client.post('/software-registration-drafts/contract/current-preview', {order_id}, {...config, responseType:'blob', timeout:60000}),
  contractDocument: (order_id, config) => client.post('/software-registration-drafts/contract/document', {order_id}, {...config, responseType:'blob', timeout:60000}),
  acceptContract: payload => client.post('/software-registration-drafts/contract/accept', payload),
  acceptTestContract: payload => client.post('/software-registration-drafts/contract/accept-test', payload),
  startCheckout: order_id => client.post('/software-registration-drafts/checkout', {order_id}, {timeout:60000}),
  checkoutStatus: config => client.post('/software-registration-drafts/checkout/status', {}, {...config, timeout:60000}),
  contractPreview: config => client.post('/software-registration-drafts/contract/preview', {}, {...config, responseType:'blob'}),
  loginStatus: () => client.post('/software-registration-drafts/login/status'),
  sendCode: email => client.post('/software-registration-drafts/login/send-code', {email}),
  verifyCode: code => client.post('/software-registration-drafts/login/verify-code', {code}),
  savePassword: payload => client.post('/software-registration-drafts/login/password', payload),
  catalogue: config => client.post('/software-registration-drafts/catalogue', {}, config),
  saveContact: payload => client.post('/software-registration-drafts/contact', payload),
  saveOnboarding: payload => client.post('/software-registration-drafts/onboarding', payload),
  savePractice: payload => client.post('/software-registration-drafts/practice', payload),
  resume: config => client.post('/software-registration-drafts/resume', {}, config),
  save: payload => client.post('/software-registration-drafts', payload),
  discard: () => client.delete('/software-registration-drafts'),
  captureReferral: code => client.post('/software-referrals', { code, storage_consent: true }),
  forgetReferral: () => client.delete('/software-referrals'),
};
